import React, { useState } from 'react'
import UserManagement from '../components/UserManagement/UserManagement'

const PageUserManagement = () => {
  return <UserManagement></UserManagement>
}

export default PageUserManagement
